export const playerSports = [
	"tennis",
	"table-tennis",
	"badminton",
	"darts",
	"bowling",
];
